<template>
    <div class="min-h-screen bg-gray-100 p-6">
        <div class="max-w-6xl mx-auto">
            <!-- Header -->
            <div class="bg-white rounded-lg shadow-md p-6 mb-6">
                <div class="flex justify-between items-center">
                    <div>
                        <h1 class="text-3xl font-bold text-gray-800">Administration Restaurants</h1>
                        <p class="text-gray-600">Gestion multi-sites</p>
                    </div>
                    <router-link
                            to="/restaurantselector"
                            class="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600 transition-colors"
                    >
                        Retour à la sélection
                    </router-link>
                </div>
            </div>

            <!-- Statistics -->
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
                <div class="bg-white rounded-lg shadow-md p-6">
                    <div class="flex items-center">
                        <div class="p-3 bg-blue-100 rounded-lg">
                            <svg class="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                            </svg>
                        </div>
                        <div class="ml-4">
                            <p class="text-sm font-medium text-gray-600">Restaurants</p>
                            <p class="text-2xl font-semibold text-gray-900">{{ restaurants.length }}</p>
                        </div>
                    </div>
                </div>

                <div class="bg-white rounded-lg shadow-md p-6">
                    <div class="flex items-center">
                        <div class="p-3 bg-green-100 rounded-lg">
                            <svg class="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                        </div>
                        <div class="ml-4">
                            <p class="text-sm font-medium text-gray-600">Serveurs</p>
                            <p class="text-2xl font-semibold text-gray-900">{{ servers.length }}</p>
                        </div>
                    </div>
                </div>

                <div class="bg-white rounded-lg shadow-md p-6">
                    <div class="flex items-center">
                        <div class="p-3 bg-yellow-100 rounded-lg">
                            <svg class="w-6 h-6 text-yellow-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                            </svg>
                        </div>
                        <div class="ml-4">
                            <p class="text-sm font-medium text-gray-600">Commandes Actives</p>
                            <p class="text-2xl font-semibold text-gray-900">{{ activeOrdersCount }}</p>
                        </div>
                    </div>
                </div>

                <div class="bg-white rounded-lg shadow-md p-6">
                    <div class="flex items-center">
                        <div class="p-3 bg-purple-100 rounded-lg">
                            <svg class="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                            </svg>
                        </div>
                        <div class="ml-4">
                            <p class="text-sm font-medium text-gray-600">Chiffre d'Affaires</p>
                            <p class="text-2xl font-semibold text-gray-900">{{ totalRevenue }}€</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Restaurants Management -->
            <div class="bg-white rounded-lg shadow-md p-6 mb-6">
                <div class="flex justify-between items-center mb-6">
                    <h2 class="text-2xl font-semibold">Gestion des Restaurants</h2>
                </div>

                <div class="space-y-4">
                    <div
                            v-for="restaurant in restaurants"
                            :key="restaurant.id"
                            class="border border-gray-200 rounded-lg p-6"
                    >
                        <div class="flex justify-between items-start">
                            <div>
                                <h3 class="text-xl font-semibold">{{ restaurant.name }}</h3>
                                <p class="text-gray-600">{{ restaurant.location }}</p>

                                <div class="mt-4 grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                                    <div>
                                        <span class="font-medium">Serveurs:</span>
                                        <span class="ml-2">
                      {{ getRestaurantServers(restaurant.id).length }}
                    </span>
                                    </div>
                                    <div>
                                        <span class="font-medium">Tables occupées:</span>
                                        <span class="ml-2">
                      {{ getOccupiedTables(restaurant.id).length }}/{{ getRestaurantTables(restaurant.id).length }}
                    </span>
                                    </div>
                                    <div>
                                        <span class="font-medium">Commandes actives:</span>
                                        <span class="ml-2">
                      {{ getRestaurantActiveOrders(restaurant.id).length }}
                    </span>
                                    </div>
                                    <div>
                                        <span class="font-medium">Caisse:</span>
                                        <span class="ml-2 capitalize" :class="getCashRegisterStatus(restaurant.id) === 'open' ? 'text-green-600' : 'text-red-600'">
                      {{ getCashRegisterStatus(restaurant.id) }}
                    </span>
                                    </div>
                                </div>
                            </div>

                            <div class="flex space-x-2">
                                <button
                                        @click="viewRestaurantDetails(restaurant)"
                                        class="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
                                >
                                    Détails
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Recent Activity -->
            <div class="bg-white rounded-lg shadow-md p-6">
                <h2 class="text-2xl font-semibold mb-4">Activité Récente</h2>

                <div v-if="recentNotifications.length === 0" class="text-gray-500 text-center py-8">
                    Aucune activité récente
                </div>

                <div v-else class="space-y-3">
                    <div
                            v-for="notification in recentNotifications"
                            :key="notification.id"
                            class="flex items-center p-3 border border-gray-200 rounded-lg"
                    >
                        <div class="flex-shrink-0 w-2 h-2 bg-blue-500 rounded-full mr-3"></div>
                        <div class="flex-1">
                            <p class="text-sm text-gray-800">{{ notification.message }}</p>
                            <p class="text-xs text-gray-500 mt-1">
                                {{ formatTime(notification.timestamp) }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'AdminRestaurants',
        computed: {
            ...mapState(['restaurants', 'servers', 'tables', 'orders', 'notifications', 'cashRegisters']),
            activeOrdersCount() {
                return this.orders.filter(order => order.status === 'active').length;
            },
            totalRevenue() {
                return this.orders
                    .filter(order => order.paid)
                    .reduce((sum, order) => sum + order.total, 0)
                    .toFixed(2);
            },
            recentNotifications() {
                return [...this.notifications]
                    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
                    .slice(0, 10);
            }
        },
        methods: {
            getRestaurantServers(restaurantId) {
                return this.servers.filter(server => server.restaurant_id === restaurantId);
            },
            getRestaurantTables(restaurantId) {
                return this.tables.filter(table => table.restaurant_id === restaurantId);
            },
            getOccupiedTables(restaurantId) {
                return this.getRestaurantTables(restaurantId).filter(table => table.status === 'occupied');
            },
            getRestaurantActiveOrders(restaurantId) {
                return this.orders.filter(order =>
                    order.restaurantId === restaurantId && order.status === 'active'
                );
            },
            getCashRegisterStatus(restaurantId) {
                const register = this.cashRegisters.find(cr => cr.restaurant_id === restaurantId);
                return register ? register.status : 'closed';
            },
            viewRestaurantDetails(restaurant) {
                alert(`Détails du restaurant: ${restaurant.name}\nLocalisation: ${restaurant.location}`);
            },
            formatTime(timestamp) {
                return new Date(timestamp).toLocaleString('fr-FR');
            }
        }
    };
</script>